module.exports = __webpack_public_path__ + "static/kp-meta-image-4b126be49173eafdc4969bb1b5f761e7.png";